export const ROLES = {
  MEMBER: 'member',
  OWNER: 'owner',
  ADMIN: 'admin',
};

export const roleForMerchant = (merchantId, roles) => {
  const roleObj = roles.find((role) => role.merchant.id === merchantId);
  return roleObj ? roleObj.name : ROLES.MEMBER;
};

export const isAdminOrOwner = ({ merchantId, roles, organizationAdmin }) => {
  if (organizationAdmin) return true;
  const role = roleForMerchant(merchantId, roles);
  return role === ROLES.ADMIN || role === ROLES.OWNER;
};
